import {
  NBS_API_GET_USER_PREFERENCES_REQUEST,
  NBS_API_GET_USER_PREFERENCES_SUCCESS,
  NBS_API_GET_USER_PREFERENCES_FAILURE
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_USER_PREFERENCES_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        status: 'request',
        timestamp: new Date().toUTCString()
      };
    case NBS_API_GET_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        status: 'success',
        timestamp: new Date().toUTCString()
      };
    case NBS_API_GET_USER_PREFERENCES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        status: 'fail',
        timestamp: new Date().toUTCString()
      };
    default:
      return state;
  }
}
